"use client";

import { useLang } from "@/contexts/language-context";
import AnimatedSection from "../AnimatedSection";
import Link from "next/link";
import { ArrowRight } from "lucide-react";

export default function NightlifeCta() {
  const { t } = useLang();

  return (
    <section className="relative py-28 px-6 bg-[#0A0814] text-white overflow-hidden">
      {/* Background glows */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-[#7C3AED]/22 rounded-full blur-[140px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-[#F472B6]/18 rounded-full blur-[140px] pointer-events-none" />

      <div className="relative max-w-[920px] mx-auto text-center">
        <AnimatedSection>
          <h2 className="text-4xl md:text-[60px] font-black leading-[1.05] tracking-tight mb-6">
            <span className="text-white">{t("Your next event.", "Tu próximo evento.")}</span>
            <br />
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(135deg, #C4B5FD 0%, #F472B6 50%, #FB923C 100%)",
              }}
            >
              {t("Without the chaos.", "Sin el caos.")}
            </span>
          </h2>
          <p className="text-[16px] md:text-[18px] font-medium text-white/60 max-w-[640px] mx-auto leading-relaxed mb-10">
            {t(
              "Plans start at $147/month for Redy Nightlife, month to month. Try it on your next event — if you'd rather go back to your old ticketing platform, you can.",
              "Los planes empiezan en $147/mes con Redy Nightlife, mes a mes. Pruébalo en tu próximo evento — si prefieres volver a tu plataforma de tickets anterior, puedes."
            )}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              href="/signup?vertical=nightlife"
              className="group inline-flex items-center gap-2 text-[15px] font-bold text-white px-8 py-4 rounded-full shadow-lg transition-all active:scale-95"
              style={{
                backgroundImage: "linear-gradient(135deg, #7C3AED 0%, #F472B6 100%)",
              }}
            >
              {t("Get started", "Comenzar")}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              href="/pricing"
              className="inline-flex items-center gap-2 text-[15px] font-bold text-white px-8 py-4 rounded-full border border-white/15 bg-white/5 backdrop-blur-xl hover:bg-white/10 transition-all"
            >
              {t("See Nightlife pricing", "Ver planes Nightlife")}
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
